import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Menu, MenuItem } from '@material-ui/core'
import {
  ExpandLessRounded as UpIcon,
  ExpandMoreRounded as DownIcon,
} from '@material-ui/icons'
import Typography from '../display/typography'
import useStyles from './selectFieldMiniStyle'

const SelectField = (props) => {
  const classes = useStyles()
  const activeConversation = useSelector((state) => state.activeConversation)
  const conversations = useSelector(
    (state) => state.conversations.conversations
  )
  const conversationSkill = conversations[activeConversation].skillId
  const [anchorEl, setAnchorEl] = useState(null)
  const [skillId, setSkillId] = useState()
  const [skillName, setSkillName] = useState()

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOpenMenu = (event) => {
    event.stopPropagation()
    props.setSelectedSkill(skillId)
    setAnchorEl(event.currentTarget)
  }

  const handleSelectItem = (event, id, name) => {
    event.stopPropagation()
    setAnchorEl(null)
    props.setSelectedSkill(id)
    setSkillId(id)
    setSkillName(name)
  }

  useEffect(() => {
    let userHaveCvSkill = Object.entries(props?.el?.skills?.[0]).find(
      (element) => element[0] === conversationSkill
    )
    if (userHaveCvSkill) {
      props.setSelectedSkill(userHaveCvSkill[0])
      setSkillId(userHaveCvSkill[0])
      setSkillName(userHaveCvSkill[1])
    } else {
      const firstSkill = Object.entries(props?.el?.skills?.[0])?.[0]
      const id = firstSkill?.[0]
      const name = firstSkill?.[1]
      props.setSelectedSkill(id)
      setSkillId(id)
      setSkillName(name)
    }
  }, [])

  return (
    <>
      <div className={classes.root} onClick={handleOpenMenu}>
        <div className={classes.content}>
          <Typography variant="body1" style={{ color: '#fff' }}>
            {skillName}
          </Typography>
        </div>
        <DownIcon style={{ color: '#fff' }} />
      </div>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 48 * 4.5,
            width: '30ch',
          },
        }}
      >
        {Object.entries(props?.el?.skills?.[0])?.map((el) => {
          const id = el[0]
          const name = el[1]
          return (
            <MenuItem
              onClick={(event) => {
                handleSelectItem(event, id, name)
              }}
            >
              {name}
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}

export default SelectField
